import { render, staticRenderFns } from "./TextSlider.vue?vue&type=template&id=2613f593&scoped=true&"
import script from "./TextSlider.vue?vue&type=script&lang=js&"
export * from "./TextSlider.vue?vue&type=script&lang=js&"
import style0 from "./TextSlider.vue?vue&type=style&index=0&id=2613f593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613f593",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
